export const POST = 'POST';
export const PUT = 'PUT';
export const GET = 'GET';
export const PATCH = 'PATCH';
export const DELETE = 'DELETE';
export const OPS_PORTAL = 'ops-portal';
export const TOKEN_KEY = 'accessToken';

export const TRACE_ID = 'x-request-id';
export const COMPONENT = 'react-component';
export const COMMON_HEADERS = {
  'Content-Type': 'application/json',
  credentials: 'include',
  Portal: process.env.NEXT_PUBLIC_PORTAL
};

export const AUTH_HEADERS = {
  ...COMMON_HEADERS,
  Authorization: 'Bearer token'
};

export const UNAUTHORIZED_MESSAGE =
  'Your Session has expired, Please login again to continue';

export const CREATE_TICKET_API_URL = '/api/tickets/create';
export const CREATE_TICKET_SERVER_API_URL = `${process.env.NEXT_PUBLIC_BFF_URL}/tickets/create`;
